import React from 'react';

/**
 * Display typing indicator animation while waiting for AI response
 */
export function TypingIndicator() {
  return (
    <div className="chat-typing-indicator">
      <div style={{ fontSize: 10, color: 'var(--ink-4)', letterSpacing: '0.1em', textTransform: 'uppercase', alignSelf: 'flex-end', marginBottom: 6 }}>
        PropAtlas Advisor
      </div>
      <div className="chat-typing-dots">
        {[0, 1, 2].map(i => (
          <span key={i} className={`chat-typing-dot chat-dot-${i}`} />
        ))}
      </div>
    </div>
  );
}
